import ym from 'react-yandex-metrika';
import { put, takeLatest, all } from 'redux-saga/effects';

import { actions as lessonActions } from 'common.components/lesson';

import { addLesson } from './actions';
import { ADD_LESSON } from './constants';

export function* emptyStateSagasWatcher() {
    yield all([takeLatest(ADD_LESSON, addLessonSaga)]);
}

function* addLessonSaga(action: ReturnType<typeof addLesson>) {
    const {
        goalParams: { goalId, ...params },
    } = action;

    yield put(lessonActions.clearEditor());

    ym('reachGoal', goalId, params);
}
